module.exports = __webpack_public_path__ + "img/190a4126d118b8446366bbb45d928108.png";